import { Icon, IconType } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { ssoLogout } from 'common/services/sso'
import firebase from 'firebase/compat/app'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { unsubscribe } from '../../../common/services/firebase/data'

export const LogoutButton = () => {
  const { t } = useTranslation()

  const dispatch = useDispatch()

  const signOut = () => dispatch(ssoLogout() as any)

  const handleSignOut = () => {
    try {
      signOut()
        .then(() => firebase.messaging().getToken())
        .then((token: string) => unsubscribe(token))
        .then(() => {
          window.location.replace('/')
        })
        .catch((err: unknown) => {
          // eslint-disable-next-line no-console
          console.log(err)
          window.location.replace('/')
        })
    } catch (e) {
      window.location.replace('/')
    }
  }

  return (
    <Wrapper onClick={handleSignOut}>
      <StyledText>{t(`general.buttons.signOut`)}</StyledText>
      <Icon
        customIcon={IconType.LogoutIcon}
        style={{ height: 16, width: 16 }}
      />
    </Wrapper>
  )
}

const StyledText = styled(Text)`
  color: ${({ theme }) => theme.palette.lmcPink};
  margin-right: 10px;
`
const Wrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-top: 10px;
  z-index: 10;
`
